import invitationService from "../services/invitationService";

export default {
  namespaced: true,

  state: {
    pendingInvitations: 0,
    availableConnectionsCount: 0,
  },

  mutations: {
    setPendingInvitations: async state => {
      let pendingInvitations = await invitationService.getPending();
      state.pendingInvitations = pendingInvitations.length;
    },
    removePendingInvitation: state => {
      --state.pendingInvitations;
    },
    setAvailableConnectionsCount: (state, count) => {
      state.availableConnectionsCount = count;
    },
    removeAvailableConnectionsCount: state => {
      --state.availableConnectionsCount;
    },
  },
  getters: {
    pendingInvitations: state => state.pendingInvitations,
    availableConnectionsCount: state => state.availableConnectionsCount,
  },
  actions: {
    setPendingInvitations({ commit }) {
      commit("setPendingInvitations");
    },
    removePendingInvitation({ commit }) {
      commit("removePendingInvitation");
    },
    setAvailableConnectionsCount({ commit }, count) {
      commit("setAvailableConnectionsCount", count);
    },
    removeAvailableConnectionsCount({ commit }) {
      commit("removeAvailableConnectionsCount");
    },
  },
};
